/*
 * Copyright (c) Nexign, JSC, 2021.
 */
/**
 *
 *
 * @author Yakov Gushchin
 * @version 1.13.0
 * @since 1.13.0
 */

import { SkeletonParagraph } from '../../../../../components/common';
import { ESkeletonKind } from '../../../../../components/common/Skeleton/skeletonTypes';
import { WidgetSkeletonChart } from '../../../../PageDashboard/components/Widgets/constants/widgetSkeletonContants';
import { SubscriberIdSkeletonStyled } from '../../styled/PageSubscriberIdStyled';
import { SubscriberIdFinanceConfiguration } from './subscriberIdFinancesConstant';

const SubscriberIdFinancesSkeleton = () => {
    const legendStyle = { width: 300, marginBottom: 24 };
    return (
        <SubscriberIdSkeletonStyled style={{ display: 'flex', justifyContent: 'space-between' }}>
            <div style={{ width: 500 }}>
                <SkeletonParagraph kind={ESkeletonKind.PARAGRAPH_NORMAL}/>
                <SkeletonParagraph kind={ESkeletonKind.PARAGRAPH_SMALL} style={legendStyle}/>
                <SkeletonParagraph kind={ESkeletonKind.PARAGRAPH_SMALL} style={legendStyle}/>
                <SkeletonParagraph kind={ESkeletonKind.PARAGRAPH_SMALL} style={legendStyle}/>
                <SkeletonParagraph kind={ESkeletonKind.PARAGRAPH_SMALL} style={legendStyle}/>
                <SkeletonParagraph kind={ESkeletonKind.PARAGRAPH_SMALL} style={legendStyle}/>
                <SkeletonParagraph kind={ESkeletonKind.PARAGRAPH_SMALL} style={legendStyle}/>
            </div>
            <WidgetSkeletonChart
                kind={ESkeletonKind.CHART_DONUT}
                multiple={SubscriberIdFinanceConfiguration.skeleton.multiple}
            />
        </SubscriberIdSkeletonStyled>
    );
};

export default SubscriberIdFinancesSkeleton;
